import { useRef, useState } from "react";
import { ImagePlus, RotateCcw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { LogoMark } from "@/components/Logo";

/** Panel logo perusahaan — unggah PNG/JPG/WEBP/SVG ≤1MB, dipakai di header, login & semua dokumen cetak */
export function LogoSettings({ isAdmin }) {
  const { branding, refreshBranding } = useApp();
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData(); fd.append("file", file);
    try {
      await api.post("/settings/logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await refreshBranding();
      toast.success("Logo diperbarui / 标志已更新");
    } catch (e) { toast.error(fmtErr(e)); }
    setBusy(false);
    if (fileRef.current) fileRef.current.value = "";
  };

  const reset = async () => {
    setBusy(true);
    try { await api.delete("/settings/logo"); await refreshBranding(); toast.success("Logo dikembalikan ke bawaan"); } catch (e) { toast.error(fmtErr(e)); }
    setBusy(false);
  };

  return (
    <div className="panel max-w-xl space-y-4 p-5" data-testid="settings-logo-panel">
      <div>
        <div className="font-display text-sm font-bold text-slate-200">Logo Perusahaan <span className="cn text-[11px] font-normal text-slate-500">公司标志</span></div>
        <p className="mt-1 text-xs text-slate-500">Tampil di header aplikasi, halaman login, label barcode, SPK, STB, tagihan dan laporan cetak. Gunakan PNG transparan lebar ±600px (maks. 1MB).</p>
      </div>
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex h-20 min-w-[12rem] items-center justify-center rounded border border-slate-800 bg-slate-950 px-4" data-testid="settings-logo-preview-dark"><LogoMark size={48} /></div>
        <div className="flex h-20 min-w-[12rem] items-center justify-center rounded border border-slate-300 bg-white px-4" data-testid="settings-logo-preview-light"><LogoMark size={48} /></div>
      </div>
      {isAdmin && (
        <div className="flex flex-wrap gap-2">
          <input ref={fileRef} type="file" accept=".png,.jpg,.jpeg,.webp,.svg" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="settings-logo-file" />
          <Button onClick={() => fileRef.current?.click()} disabled={busy} className="bg-sky-600 hover:bg-sky-500" data-testid="settings-logo-upload-button">
            {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <ImagePlus className="mr-1.5 h-4 w-4" />}Unggah Logo Baru
          </Button>
          <Button variant="outline" className="border-slate-700" disabled={busy || !branding?.logoDataUrl} onClick={reset} data-testid="settings-logo-reset-button"><RotateCcw className="mr-1.5 h-4 w-4" />Kembalikan Bawaan</Button>
        </div>
      )}
    </div>
  );
}
